import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import firestore from './firebase';

const TicketForm = ({ addTicket }) => {
  const [trainDetails, setTrainDetails] = useState({
    trainNo: '',
    trainName: '',
    source: '',
    destination: '',
    departureTime: '',
    arrivalTime: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const ticket = { ...trainDetails, status: 'Available' };

      // Save ticket to Firestore
      const ticketsCollection = collection(firestore, 'tickets');
      const docRef = await addDoc(ticketsCollection, ticket);

      // Retrieve the unique ID generated by Firestore and include it in the ticket object
      const updatedTicket = { id: docRef.id, ...ticket };

      addTicket(updatedTicket);
      setTrainDetails({
        trainNo: '',
        trainName: '',
        source: '',
        destination: '',
        departureTime: '',
        arrivalTime: '',
      });
    }
  };

  const validateForm = () => {
    // Add your validation logic here
    return true;
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Train No & DOJ"
        value={trainDetails.trainNo}
        onChange={(e) => setTrainDetails({ ...trainDetails, trainNo: e.target.value })}
      />
      <input
        type="text"
        placeholder="Train Name"
        value={trainDetails.trainName}
        onChange={(e) => setTrainDetails({ ...trainDetails, trainName: e.target.value })}
      />
      <input
        type="text"
        placeholder="Source"
        value={trainDetails.source}
        onChange={(e) => setTrainDetails({ ...trainDetails, source: e.target.value })}
      />
      <input
        type="text"
        placeholder="Destination"
        value={trainDetails.destination}
        onChange={(e) => setTrainDetails({ ...trainDetails, destination: e.target.value })}
      />
      <input
        type="text"
        placeholder="Departure Time"
        value={trainDetails.departureTime}
        onChange={(e) => setTrainDetails({ ...trainDetails, departureTime: e.target.value })}
      />
      <input
        type="text"
        placeholder="Seller Phone No"
        value={trainDetails.arrivalTime}
        onChange={(e) => setTrainDetails({ ...trainDetails, arrivalTime: e.target.value })}
      />
      <button className='dibbobutton' type="submit">Add Ticket</button>
    </form>
  );
};

export default TicketForm;
